import {
  interactionClickInstallMerchantAdmin,
  InteractionClickInstallMerchantAdminProperties,
  pwaAppInstalled,
} from 'core/telemetry/avo/Avo';

export const telemetryClickInstallFromBanner = () => {
  const properties: InteractionClickInstallMerchantAdminProperties = {
    clickTarget: 'install_pwa',
  };

  interactionClickInstallMerchantAdmin(properties);
};

export const telemetryClickInstallFromUserDropDown = () => {
  const properties: InteractionClickInstallMerchantAdminProperties = {
    clickTarget: 'install_pwa_user_dropdown',
  };

  interactionClickInstallMerchantAdmin(properties);
};

export const telemetryPWAInstalled = () => {
  pwaAppInstalled();
};

export const telemetryClickIOSInstructions = () => {
  const properties: InteractionClickInstallMerchantAdminProperties = {
    clickTarget: 'ios_view_instruction',
  };

  interactionClickInstallMerchantAdmin(properties);
};
